import { useFlags } from "../../server/optimizely";

export function useBrainfish():
  | {
      loading: true;
      widgetKey: null;
    }
  | {
      loading: false;
      widgetKey: string | null;
    } {
  const {
    flagsLoaded,
    flags: { brainfish, brainfish_ambient },
  } = useFlags("brainfish", "brainfish_ambient");

  if (!flagsLoaded) return { loading: true, widgetKey: null };

  if (brainfish_ambient)
    return { loading: false, widgetKey: "bf_agent_MjFIPB8LNILLvKU32f6zw7FH2NKeA2yZ11jIDC" };
  if (brainfish)
    return { loading: false, widgetKey: "bf_agent_ZwOTp7r4fEqBd5MRWYrJntMhM2SD5Pp7t4oBpo" };
  return { loading: false, widgetKey: null };
}
